import { TrashIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedTaskUpdateDeletedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityActions,
  ActivityBody,
  ActivityIcon,
  ActivityItem,
  ActivityLink,
  ActivityTitle,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface TaskUpdateDeletedEventProps {
  event: DiscriminatedTaskUpdateDeletedEvent;
}

export const TaskUpdateDeletedEvent: React.FC<TaskUpdateDeletedEventProps> = ({
  event,
}) => {
  const { task_update } = event.payload;
  const user = getUserFromEvent(event);

  const entityName = task_update?.update
    ? `${task_update.update.substring(0, 50)}...`
    : 'Comment';

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-red-100">
          <TrashIcon className="h-4 w-4 text-red-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      <ActivityTitle>{entityName}</ActivityTitle>
    </ActivityBody>
  );

  const actions = task_update?.task_id && (
    <ActivityActions>
      <ActivityLink
        href={`/matters/${event.matter_id}/updates?task_id=${task_update.task_id}`}
      >
        View Task
      </ActivityLink>
    </ActivityActions>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Task Comment Deleted"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
      actions={actions}
    />
  );
};
